<template>
  <div class="row wrapper border-bottom white-bg page-heading py-1 px-0">
    <div class="col-8 align-self-center">
      <h2>{{ tocHeading }}</h2>
    </div>
    <!-- <div class="col-2 align-self-end" v-if="showFilterBtn==true && $store.getters.getVersion">
      <label v-if="versionList!=null" class="mb-0" for="interimSelectedVersion">{{ $t("navigations.interim version")}}</label>
      <input disabled type="text" v-model="interimSelectedVersion" class="form-control" name="" id="interimSelectedVersion">
    </div> -->
    <div class="col-4 col-4 d-flex justify-contnet-between align-items-center">
      <label
        v-if="versionList != null"
        class="mb-0 w-100 text-right mr-2"
        for="interimVersion"
        >{{ $t("navigations.interim version") }}</label
      >
      <select
        class="form-select"
        @change="setVersionNo()"
        name="interimVersion"
        id="interimVersion"
        v-model="interimVersion"
      >
        <option
          v-for="version in interimData"
          :key="version._id"
          :value="version.InterimVersion"
        >
          {{ version.InterimVersion }}
        </option>
      </select>
      <button
        v-if="showFilterBtn"
        class="py-1 pl-3 pr-0 position-relative settings-block"
        :class="{ 'tooltip-hidden': openSettings == true }"
        @click="openSettings = true"
      >
        <i class="fa fa-ellipsis-v px-2"></i>
        <div class="settings-tooltip">
          {{ $t("navigations.show more options") }}
        </div>
      </button>
      <div
        class="toc-side-popup right-25"
        v-if="openSettings == true"
        v-on:clickout="openSettings = false"
      >
        <div @click.prevent="openModal('assign', childlabels)">
          {{ $t("navigations.assign programmers") }}
        </div>
        <div @click.prevent="openStatsModal('', childlabels)">
          {{ $t("navigations.data set configuration") }}
        </div>
      </div>
    </div>
  </div>
  <div class="wrapper wrapper-content px-0">
    <div class="ibox-content">
      <div class="row" :class="{ 'justify-content-end': showFilterBtn }">
        <div
          class="col-12 col-md-12 d-flex flex-wrap flex-column"
          v-if="showFilterBtn"
        >
          <!-- First row: Program status badges -->
          <div class="d-flex flex-wrap mb-2">
            <button
              class="stat-badge badge-border-black border-2 border-bottom cursor-pointer py-1 px-2 mr-2"
              role="button"
              :class="{
                'opacity-05': activeBadge && activeBadge == 'No Program',
              }"
              @click.prevent="fetchToC('No Program')"
            >
              <span class="custom-badge badge-black status-b-radius mr-1"></span
              >{{ $t("navigations.no program") }} :
              <span class="bold">{{ programmerCount }}</span>
            </button>
            <button
              class="stat-badge badge-border-yellow border-2 border-bottom cursor-pointer py-1 px-2 mr-2"
              role="button"
              :class="{
                'opacity-05': activeBadge && activeBadge == 'In Development',
              }"
              @click.prevent="fetchToC('In Development')"
            >
              <span
                class="custom-badge badge-warning status-b-radius mr-1"
              ></span
              >{{ $t("navigations.in development") }} :
              <span class="bold">{{ developmentCount }}</span>
            </button>
            <button
              class="stat-badge badge-border-red border-2 border-bottom cursor-pointer py-1 px-2 mr-2"
              role="button"
              :class="{
                'opacity-05':
                  activeBadge && activeBadge == 'Ready For Validation',
              }"
              @click.prevent="fetchToC('Ready For Validation')"
            >
              <span
                class="custom-badge badge-danger status-b-radius mr-1"
              ></span
              >{{ $t("navigations.ready for validation") }} :
              <span class="bold">{{ readyForValidation }}</span>
            </button>
            <button
              class="stat-badge badge-border-green border-2 border-bottom cursor-pointer py-1 px-2 mr-2"
              role="button"
              :class="{
                'opacity-05': activeBadge && activeBadge == 'Validated',
              }"
              @click.prevent="fetchToC('Validated')"
            >
              <span class="custom-badge badge-grn status-b-radius mr-1"></span
              >{{ $t("navigations.validated") }} :
              <span class="bold">{{ validated }}</span>
            </button>
          </div>
          <!-- Second row: Output status badges -->
          <div class="d-flex flex-wrap">
            <button
              class="stat-badge badge-border-black border-2 border-bottom cursor-pointer py-1 px-2 mr-2"
              role="button"
              :class="{
                'opacity-05': activeBadge && activeBadge == 'No Output',
              }"
              @click.prevent="fetchToC('No Output')"
            >
              <span class="custom-badge badge-black rounded-radius mr-1"></span
              >{{ $t("navigations.no output") }} :
              <span class="bold">{{ noOutput }}</span>
            </button>
            <button
              class="stat-badge badge-border-red border-2 border-bottom cursor-pointer py-1 px-2 mr-2"
              role="button"
              :class="{
                'opacity-05': activeBadge && activeBadge == 'Old Output',
              }"
              @click.prevent="fetchToC('Old Output')"
            >
              <span class="custom-badge badge-danger rounded-radius mr-1"></span
              >{{ $t("navigations.old output") }} :
              <span class="bold">{{ oldOutput }}</span>
            </button>
            <button
              class="stat-badge badge-border-yellow border-2 border-bottom cursor-pointer py-1 px-2 mr-2"
              role="button"
              :class="{
                'opacity-05': activeBadge && activeBadge == 'Current Output',
              }"
              @click.prevent="fetchToC('Current Output')"
            >
              <span
                class="custom-badge badge-warning rounded-radius mr-1"
              ></span
              >{{ $t("navigations.current output") }} :
              <span class="bold">{{ currentOutput }}</span>
            </button>
            <button
              class="stat-badge badge-border-green border-2 border-bottom cursor-pointer py-1 px-2"
              role="button"
              :class="{
                'opacity-05': activeBadge && activeBadge == 'Stat Qc',
              }"
              @click.prevent="fetchToC('Stat Qc')"
            >
              <span class="custom-badge badge-grn rounded-radius mr-1"></span
              >{{ $t("navigations.stat qc") }} :
              <span class="bold">{{ QCStats }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="d-flex justify-content-between align-items-center ibox-title style_2"
    >
      <div class="d-flex flex-wrap">
        <button
          v-if="showFilterBtn"
          @click="expandCollapse('expand')"
          type="button"
          class="btn btn-sm btn-outline-secondary py-0 d-flex align-items-center mr-2"
          :class="{ 'disabled-btn-cls': showLoading == true }"
        >
          <i class="fa fa-expand pr-2"></i>
          <div
            :class="{
              'opacity-1': showLoading == false,
              'opacity-0': showLoading == true,
            }"
          >
            {{ $t("navigations.expand all") }}
          </div>
        </button>
        <button
          v-if="showFilterBtn"
          type="button"
          class="btn btn-sm btn-outline-secondary py-0 d-flex align-items-center mr-2"
          @click="expandCollapse('collapse')"
          :class="{ 'disabled-btn-cls': showLoading == true }"
        >
          <i class="fa fa-compress pr-2"></i>
          <div
            :class="{
              'opacity-1': showLoading == false,
              'opacity-0': showLoading == true,
            }"
          >
            {{ $t("navigations.collapse all") }}
          </div>
        </button>
        <button
          v-if="showFilterBtn"
          type="button"
          class="btn btn-sm btn-outline-secondary py-0 d-flex align-items-center"
          @click="expandCollapse('sections')"
          :class="{ 'disabled-btn-cls': showLoading == true }"
        >
          <i class="fa fa-th-large pr-2"></i>
          <div
            :class="{
              'opacity-1': showLoading == false,
              'opacity-0': showLoading == true,
            }"
          >
            {{ $t("navigations.show sections") }}
          </div>
        </button>
        <button
          v-if="showGenerateBtn == true"
          type="button"
          class="btn btn-sm btn-primary py-0 position-relative"
          @click="generateVersion()"
        >
          <div>{{ $t("navigations.generate toc") }}</div>
        </button>
      </div>
      <div class="d-flex justify-content-between" v-if="showFilterBtn">
        <button
          type="button"
          class="btn btn-sm btn-primary py-0 mr-2 position-relative d-flex align-items-center"
          @click.prevent="openModal('run')"
          :class="{ 'disabled-btn-cls': showLoading == true }"
        >
          <i class="fa fa-play-circle pr-2"></i>
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': showLoading == false,
              'opacity-1': showLoading == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <div
            :class="{
              'opacity-1': showLoading == false,
              'opacity-0': showLoading == true,
            }"
          >
            {{ $t("navigations.run programs") }}
          </div>
        </button>
        <button
          type="button"
          @click.prevent="openProgramRunStatusModal()"
          class="btn btn-sm btn-primary py-0 mr-2 position-relative d-flex align-items-center"
          :class="{ 'disabled-btn-cls': showLoading == true }"
        >
          <i class="fa fa-list-ul pr-2"></i>
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': showLoading == false,
              'opacity-1': showLoading == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <div
            :class="{
              'opacity-1': showLoading == false,
              'opacity-0': showLoading == true,
            }"
          >
            {{ $t("navigations.program run status") }}
          </div>
        </button>
        <span
          class="position-relative cursor-pointer px-2"
          @click.prevent="showFilter = !showFilter"
          ><img
            class="cursor-pointer"
            src="../../assets/img/filter.png"
            width="17"
            height="17"
            alt="filter table"
          />
          <span class="settings-tooltip">{{
            $t("navigations.filter")
          }}</span></span
        >
      </div>
    </div>
    <!-- Filter section starts -->
    <div class="ibox-content">
      <div v-if="showFilter" class="my-1">
        <div class="row justify-content-end">
          <div class="col-4">
            <label for="sectionFilterSection">{{
              $t("navigations.filter by programmers")
            }}</label>
            <Multiselect
              id="sectionFilterSection"
              mode="tags"
              class="multiselect-theme"
              v-model="usersValues"
              :label="'fullName'"
              :valueProp="'fullName'"
              @update:modelValue="fetchToC(lastStatus || '', 'filters')"
              :options="formattedUsersList"
              :hideSelected="false"
              :closeOnSelect="false"
            >
              <template v-slot:option="{ option }">
                {{ option.fullName }}
              </template>
            </Multiselect>
          </div>
          <div class="col-4">
            <label for="sectionFilterSection">{{
              $t("navigations.filter by section")
            }}</label>
            <Multiselect
              id="sectionFilterSection"
              mode="tags"
              class="multiselect-theme"
              v-model="headerNames"
              :label="'label'"
              @update:modelValue="fetchToC(lastStatus || '', 'filters')"
              :options="headingList"
              :hideSelected="false"
              :closeOnSelect="false"
            >
              <template v-slot:option="{ option }">
                {{ option.label }}
              </template>
            </Multiselect>
          </div>
          <div class="col-4">
            <label for="sectionFilterReport">{{
              $t("navigations.filter by report type")
            }}</label>
            <Multiselect
              id="sectionFilterReport"
              mode="tags"
              class="multiselect-theme"
              v-model="reportType"
              :options="options"
              :hideSelected="false"
              :closeOnSelect="false"
              @update:modelValue="fetchToC(lastStatus || '', 'filters')"
            />
          </div>
        </div>
      </div>
      <!-- Filter section ends -->

      <!-- Tree View -->
      <div class="text-center" v-if="initialTreeLoader">
        <div>
          {{ $t("navigations.please wait while the tree is being generated") }}
        </div>
        <img
          src="../../assets/img/loading.gif"
          width="15"
          alt="Waiting for login"
        />
      </div>

      <div v-if="showTree && !initialTreeLoader" class="tree-container">
        <ul class="tree">
          <!-- Top-Level Nodes -->
          <li v-for="(node, index) in Object.keys(treeData)" :key="index">
            <input type="checkbox" :id="index" :checked="expandAll == true" />
            <label class="tree_label mr-3" :for="index"
              ><span
                :class="{
                  'highlighted-background p-1':
                    treeData[node].Headinglock == true || tocLock == true,
                }"
                >{{ treeData[node].Headingindex }}
                {{ treeData[node].Headingname
                }}<i
                  class="fa fa-lock px-2"
                  v-if="treeData[node].Headinglock == true || tocLock == true"
                ></i></span
            ></label>

            <!-- Action Buttons for Top-Level Nodes -->
            <button
              :popovertarget="`headerMenu-${index}`"
              :anchor="`headerMenu-${index}`"
              class="ellipsis-btn py-2 px-3"
            >
              <i class="fa fa-ellipsis-v"></i>
            </button>
            <!-- <span
            v-if="showFilterBtn"
              class="position-relative level-menu cursor-pointer py-2 px-3"
              @click.prevent="toggleSidePopup(index)"
              v-on:clickout="closeSidePopup(index)"
            >
              <i class="fa fa-ellipsis-v"></i>
            </span> -->
            <div :id="`headerMenu-${index}`" popover class="popup-menu">
              <button
                :popovertarget="`manageHeaderentry-${node}`"
                v-if="tocLock != true"
                class="w-100 d-flex justify-content-between align-items-center"
              >
                {{ $t("navigations.manage section") }}
                <i class="fa fa-angle-right fs-6"></i>
              </button>
              <div
                :id="`manageHeaderentry-${node}`"
                popover
                class="popup-submenu"
              >
                <div
                  v-if="treeData[node].Headinglock != true && tocLock != true"
                  class="popup-menu-block w-100"
                  @click.prevent="
                    Addheadnodeafter(
                      treeData[node].Headingid,
                      `headerMenu-${index}`
                    )
                  "
                >
                  {{ $t("navigations.add headnode after") }}
                </div>

                <div
                  v-if="treeData[node].Headinglock != true && tocLock != true"
                  class="popup-menu-block w-100"
                  @click.prevent="
                    Addheadnodebefore(
                      treeData[node].Headingid,
                      `headerMenu-${index}`
                    )
                  "
                >
                  {{ $t("navigations.add headnode before") }}
                </div>
                <div
                  v-if="treeData[node].Headinglock != true && tocLock != true"
                  class="popup-menu-block w-100"
                  @click="
                    Editheading(
                      treeData[node].Headingid,
                      treeData[node].Headingname,
                      `headerMenu-${index}`
                    )
                  "
                >
                  {{ $t("navigations.edit") }}
                </div>
                <div
                  v-if="treeData[node].Headinglock != true && tocLock != true"
                  class="popup-menu-block w-100"
                  @click.prevent="
                    DeleteHeading(
                      treeData[node].Headingid,
                      treeData[node].Headingindex,
                      `headerMenu-${index}`
                    )
                  "
                >
                  {{ $t("navigations.delete") }}
                </div>
                <div
                  v-if="treeData[node].Headinglock != true"
                  class="popup-menu-block w-100"
                  @click.prevent="
                    lockEntry(
                      '',
                      treeData[node].Headingid,
                      '',
                      `headerMenu-${index}`,
                      'lock',
                      'header'
                    )
                  "
                >
                  {{ $t("navigations.lock section") }}
                </div>
                <div
                  v-if="treeData[node].Headinglock == true && tocLock != true"
                  class="popup-menu-block w-100"
                  @click.prevent="
                    lockEntry(
                      '',
                      treeData[node].Headingid,
                      '',
                      `headerMenu-${index}`,
                      'unlock',
                      'header'
                    )
                  "
                >
                  {{ $t("navigations.unlock section") }}
                </div>
              </div>
              <div
                v-if="treeData[node].Headinglock != true && tocLock != true"
                class="popup-menu-block w-100"
                @click.prevent="
                  openEntryUpdate(
                    '',
                    treeData[node].Headingid,
                    `headerMenu-${index}`,
                    'add'
                  )
                "
              >
                {{ $t("navigations.add report") }}
              </div>
            </div>
            <!-- Reports for Each Node -->
            <ul v-if="treeData[node].Reports.length != 0">
              <li
                v-for="(childlabels, reportIndex) in treeData[node].Reports"
                :key="childlabels.Reportid || reportIndex"
              >
                <label class="tree_label mr-3" :for="childlabels.Reportid"
                  ><span
                    :class="{
                      'highlighted-background p-1':
                        childlabels.Reportlock == true || tocLock == true,
                    }"
                    >{{ childlabels.Subindex }} {{ childlabels.Reportname
                    }}<i
                      class="fa fa-lock px-2"
                      v-if="childlabels.Reportlock == true || tocLock == true"
                    ></i></span
                ></label>
                <button
                  :popovertarget="`submenu-${node}-${reportIndex}`"
                  :anchor="`submenu-${node}-${reportIndex}`"
                  class="ellipsis-btn py-2 px-3"
                >
                  <i class="fa fa-ellipsis-v"></i>
                </button>
                <div
                  :id="`submenu-${node}-${reportIndex}`"
                  popover
                  class="popup-menu"
                >
                  <button
                    v-if="
                      (childlabels.Reportlock == false ||
                        childlabels.Reportlock == null) &&
                      tocLock != true
                    "
                    :popovertarget="`manageReportEntry-${node}-${reportIndex}`"
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    {{ $t("navigations.manage section") }}
                    <i class="fa fa-angle-right fs-6"></i>
                  </button>
                  <button
                    v-if="
                      (childlabels.Reportlock == false ||
                        childlabels.Reportlock == null) &&
                      childlabels.Programms != null &&
                      childlabels.Programms.length !== 0 &&
                      tocLock != true
                    "
                    :popovertarget="`manageReportOutput-${node}-${reportIndex}`"
                    class="w-100 d-flex justify-content-between align-items-center"
                  >
                    {{ childlabels.Programs }}
                    {{ $t("navigations.manage output") }}
                    <i class="fa fa-angle-right fs-6"></i>
                  </button>
                  <div
                    :id="`manageReportEntry-${node}-${reportIndex}`"
                    popover
                    class="popup-submenu"
                  >
                    <div
                      class="popup-menu-block w-100"
                      @click.prevent="
                        copyMoveReport(
                          childlabels,
                          treeData[node].Headingid,
                          '',
                          `submenu-${node}-${reportIndex}`,
                          'copy',
                          'report'
                        )
                      "
                    >
                      {{ $t("navigations.copy report") }}
                    </div>
                    <div
                      class="popup-menu-block w-100"
                      @click.prevent="
                        copyMoveReport(
                          childlabels,
                          treeData[node].Headingid,
                          '',
                          `submenu-${node}-${reportIndex}`,
                          'move',
                          'report'
                        )
                      "
                    >
                      {{ $t("navigations.move report") }}
                    </div>
                    <div
                      class="popup-menu-block w-100"
                      @click.prevent="
                        openEntryUpdate(
                          childlabels,
                          treeData[node].Headingid,
                          `submenu-${node}-${reportIndex}`,
                          'update'
                        )
                      "
                    >
                      {{ $t("navigations.update report") }}
                    </div>
                    <div
                      class="popup-menu-block w-100"
                      @click.prevent="
                        openEntryUpdate(
                          childlabels,
                          treeData[node].Headingid,
                          `submenu-${node}-${reportIndex}`,
                          'delete'
                        )
                      "
                    >
                      {{ $t("navigations.delete report") }}
                    </div>
                  </div>
                  <div
                    v-if="childlabels.Reportlock == false && tocLock != true"
                    class="popup-menu-block w-100"
                    @click.prevent="goto(childlabels, 'create')"
                  >
                    {{ $t("navigations.create program") }}
                  </div>
                  <div
                    v-if="childlabels.Reportlock == false && tocLock != true"
                    class="popup-menu-block w-100"
                    @click.prevent="
                      lockEntry(
                        childlabels,
                        treeData[node].Headingid,
                        '',
                        `submenu-${node}-${reportIndex}`,
                        'lock',
                        'report'
                      )
                    "
                  >
                    {{ $t("navigations.lock section") }}
                  </div>
                  <div
                    v-if="childlabels.Reportlock == true && tocLock != true"
                    class="popup-menu-block w-100"
                    @click.prevent="
                      lockEntry(
                        childlabels,
                        treeData[node].Headingid,
                        '',
                        `submenu-${node}-${reportIndex}`,
                        'unlock',
                        'report'
                      )
                    "
                  >
                    {{ $t("navigations.unlock section") }}
                  </div>
                  <button
                    v-if="
                      (childlabels.Reportlock == false ||
                        childlabels.Reportlock == null) &&
                      tocLock != true
                    "
                    class="w-100 text-left"
                    @click.prevent="
                      openMap(childlabels, `submenu-${node}-${reportIndex}`)
                    "
                  >
                    {{ $t("navigations.map macro") }}
                  </button>
                  <div
                    :id="`manageReportOutput-${node}-${reportIndex}`"
                    popover
                    class="popup-submenu"
                    v-if="childlabels.Reportlock == false && tocLock != true"
                  >
                    <div
                      @click.prevent="
                        deleteOutput(
                          childlabels.Reportid,
                          '',
                          `submenu-${node}-${reportIndex}`
                        )
                      "
                    >
                      {{ $t("navigations.delete output") }}
                    </div>
                  </div>
                </div>
                <input
                  type="checkbox"
                  :id="childlabels.Reportid"
                  :checked="expandSections == true"
                />
                <ul>
                  <li
                    v-for="(value, innerIndex) in childlabels.Programms"
                    :key="value.SourceId"
                  >
                    <label :for="value.SourceId" class="tree_label">
                      <span v-if="value.Status != 'No Program'">
                        <span
                          :class="{
                            'custom-badge badge-danger rounded-radius mr-1':
                              value.Outputstate == 'oldoutput',
                            'custom-badge badge-black rounded-radius mr-1':
                              value.Outputstate == 'nooutput',
                            'custom-badge badge-warning rounded-radius mr-1':
                              value.Outputstate == 'currentoutput',
                            'custom-badge badge-grn rounded-radius mr-1':
                              value.Outputstate == 'StatQc',
                          }"
                        ></span>
                        <span
                          :class="
                            getBadgeClass(
                              value.Status,
                              value.HasOutput,
                              'status'
                            )
                          "
                        ></span>
                      </span>
                      <span
                        :class="{
                          'highlighted-background p-1':
                            value.ProgramLock == true || tocLock == true,
                          'px-1': value.ProgramLock == true || tocLock != true,
                        }"
                        ><span
                          v-if="
                            value.Status != null && value.ReportType != null
                          "
                          >{{ value.ReportType[0] }}
                        </span>
                        {{ childlabels.Subindex }}<span>.</span
                        >{{ innerIndex + 1 }} {{ value.ProgramName }} - <strong>{{value.Version }}</strong>&nbsp;
                        <span
                          v-if="value.ProgramLock == true || tocLock == true"
                          ><i class="fa fa-lock"></i
                        ></span>
                        <input type="checkbox" :id="value.SourceId" />
                        <!-- Status and Developer Information -->
                        <template v-if="value.Status != null">
                          <span
                            v-if="
                              value.DeveloperName != 'string' &&
                              value.DeveloperName != '' &&
                              value.DeveloperName != null
                            "
                          >
                            {{ 
                              $t("navigations.primary programmer")
                            }}
                            - <strong>{{ value.DeveloperName }}</strong></span
                          >
                          <span
                            class="px-1"
                            v-if="
                              value.QCName != 'string' &&
                              value.QCName != '' &&
                              value.QCName != null
                            "
                            >|</span
                          >
                          <span
                            v-if="
                              value.QCName != 'string' &&
                              value.QCName != '' &&
                              value.QCName != null
                            "
                          >
                            {{
                              $t("navigations.qc programmer")
                            }}
                            - <strong>{{ value.QCName }}</strong></span
                          >
                        </template>
                      </span>
                    </label>
                    <!-- Action Button for Sub-Level Nodes -->
                    <button
                      :popovertarget="`submenu-${node}-${reportIndex}-${innerIndex}`"
                      :anchor="`submenu-${node}-${reportIndex}-${innerIndex}`"
                      class="ellipsis-btn py-2 px-3"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </button>

                    <!-- Popover for Sub-Level Actions -->
                    <div
                      :id="`submenu-${node}-${reportIndex}-${innerIndex}`"
                      popover
                      class="popup-menu"
                    >
                      <button
                        v-if="
                          childlabels.Reportlock == false && tocLock != true
                        "
                        :popovertarget="`manageEntry-${node}-${reportIndex}-${innerIndex}`"
                        class="w-100 d-flex justify-content-between align-items-center"
                      >
                        {{ $t("navigations.manage entry") }}
                        <i class="fa fa-angle-right fs-6"></i>
                      </button>
                      <!-- Nested Popover for Managing Programs -->
                      <button
                        v-if="childlabels.Reportlock == false"
                        :popovertarget="`manageProgram-${node}-${reportIndex}-${innerIndex}`"
                        class="w-100 d-flex justify-content-between align-items-center"
                      >
                        {{ $t("navigations.manage program") }}
                        <i class="fa fa-angle-right fs-6"></i>
                      </button>
                      <div
                        :id="`manageEntry-${node}-${reportIndex}-${innerIndex}`"
                        popover
                        class="popup-submenu"
                      >
                        <div
                          v-if="
                            (value.ProgramLock == false ||
                              value.ProgramLock == null) &&
                            tocLock != true
                          "
                          class="popup-menu-block w-100"
                          @click.prevent="
                            lockEntry(
                              childlabels,
                              treeData[node].Headingid,
                              value._id,
                              `submenu-${node}-${reportIndex}-${innerIndex}`,
                              'lock'
                            )
                          "
                        >
                          {{ $t("navigations.lock program") }}
                        </div>
                        <div
                          v-if="
                            (value.ProgramLock == false ||
                              value.ProgramLock == null) &&
                            tocLock != true
                          "
                          class="popup-menu-block w-100"
                          @click.prevent="
                            copyMoveReport(
                              childlabels,
                              treeData[node].Headingid,
                              value,
                              `submenu-${node}-${reportIndex}-${innerIndex}`,
                              'copy',
                              'program'
                            )
                          "
                        >
                          {{ $t("navigations.copy program") }}
                        </div>
                        <div
                          v-if="
                            (value.ProgramLock == false ||
                              value.ProgramLock == null) &&
                            tocLock != true
                          "
                          class="popup-menu-block w-100"
                          @click.prevent="
                            copyMoveReport(
                              childlabels,
                              treeData[node].Headingid,
                              value,
                              `submenu-${node}-${reportIndex}-${innerIndex}`,
                              'move',
                              'program'
                            )
                          "
                        >
                          {{ $t("navigations.move program") }}
                        </div>
                        <div
                          v-if="value.ProgramLock == true && tocLock != true"
                          class="popup-menu-block w-100"
                          @click.prevent="
                            lockEntry(
                              childlabels,
                              treeData[node].Headingid,
                              value._id,
                              `submenu-${node}-${reportIndex}-${innerIndex}`,
                              'lock'
                            )
                          "
                        >
                          {{ $t("navigations.unlock entry") }}
                        </div>
                      </div>
                      <div
                        :id="`manageProgram-${node}-${reportIndex}-${innerIndex}`"
                        popover
                        class="popup-submenu"
                      >
                        <div
                          class="popup-menu-block w-100"
                          v-if="
                            (value.HasProgram == false ||
                              value.HasProgram == null) &&
                            tocLock != true
                          "
                          @click.prevent="goto(childlabels, 'create')"
                        >
                          {{ $t("navigations.create program") }}
                        </div>
                        <div
                          class="popup-menu-block w-100"
                          v-if="value.HasProgram == true"
                          @click.prevent="
                            fetchProgramDetails(
                              value._id,
                              `submenu-${node}-${reportIndex}-${innerIndex}`
                            )
                          "
                        >
                          {{ $t("navigations.view program") }}
                        </div>
                        <div
                          class="popup-menu-block w-100"
                          v-if="value.HasProgram == true && tocLock != true"
                          @click.prevent="goto(childlabels, 'edit', value._id)"
                        >
                          {{ $t("navigations.edit program") }}
                        </div>
                        <div
                          class="popup-menu-block w-100"
                          @click.prevent="
                            programHistory(
                              childlabels,
                              `submenu-${node}-${reportIndex}-${innerIndex}`,
                              value
                            )
                          "
                        >
                          {{ $t("navigations.program history") }}
                        </div>
                        <div
                          class="popup-menu-block w-100"
                          v-if="tocLock != true"
                          @click.prevent="
                            changeStatus(
                              childlabels,
                              value,
                              `submenu-${node}-${reportIndex}-${innerIndex}`
                            )
                          "
                        >
                          {{ $t("navigations.change validation status") }}
                        </div>
                        <div
                          class="popup-menu-block w-100"
                          v-if="
                            value.Status !== 'No Program' && tocLock != true
                          "
                          @click.prevent="
                            runBtn(
                              'run',
                              childlabels.Reportid,
                              childlabels.Reportname,
                              value._id,
                              `submenu-${node}-${reportIndex}-${innerIndex}`,
                              childlabels.Subindex
                            )
                          "
                        >
                          {{ $t("navigations.run") }}
                        </div>
                      </div>
                      <button
                        v-if="value.HasOutput == true"
                        :popovertarget="`manageOutput-${node}-${reportIndex}-${innerIndex}`"
                        class="w-100 w-100 d-flex justify-content-between align-items-center"
                      >
                        {{ $t("navigations.manage output") }}
                        <i class="fa fa-angle-right fs-6"></i>
                      </button>
                      <div
                        :id="`manageOutput-${node}-${reportIndex}-${innerIndex}`"
                        popover
                        class="popup-submenu"
                        v-if="value.HasOutput == true"
                      >
                        <div
                          v-if="value.HasOutput == true"
                          @click.prevent="
                            runBtn(
                              'export',
                              childlabels.Reportid,
                              childlabels.Reportname,
                              value._id,
                              `submenu-${node}-${reportIndex}-${innerIndex}`
                            )
                          "
                        >
                          {{ $t("navigations.export output") }}
                        </div>
                        <div
                          v-if="value.HasOutput == true"
                          @click.prevent="
                            runBtn(
                              'output',
                              childlabels.Reportid,
                              childlabels.Reportname,
                              value._id,
                              `submenu-${node}-${reportIndex}-${innerIndex}`
                            )
                          "
                        >
                          {{ $t("navigations.view output") }}
                        </div>
                        <div
                          v-if="value.HasOutput == true"
                          @click.prevent="
                            deleteOutput(
                              childlabels.Reportid,
                              value._id,
                              `submenu-${node}-${reportIndex}-${innerIndex}`
                            )
                          "
                        >
                          {{ $t("navigations.delete output") }}
                        </div>
                      </div>
                    </div>
                  </li>
                  <!-- Action Buttons for Sub-Level Nodes -->
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Query Open model starts -->
  <teleport to="#app">
    <div class="add_page_modal_wrapper" v-if="editpopup">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0">Edit Report</h4>
          <a class="close-link">
            <i class="fa fa-times" @click.prevent="closemodal()"></i>
          </a>
        </div>

        <div
          class="form-group d-flex flex-column col-lg-10 mx-auto maxheightdesigncomplete pt-3"
        >
          <div>
            <label for="reportname" class="mt-2 mb-0">Current Name:</label>
            <input
              class="form-control"
              type="text"
              id="reportname"
              v-model="reportnamedit"
              placeholder="Edit Report Name"
              readonly
            />
          </div>
          <div>
            <label for="reportname" class="mt-2 mb-0">New Name</label>
            <input
              class="form-control"
              type="text"
              id="reportname"
              v-model="newreportname"
              placeholder="Edit Report Name"
            />
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button
              type="button"
              class="btn btn-primary px-4 py-0"
              @click="onsave()"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="add_page_modal_wrapper" v-if="Addheadnodeafterpopup">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0">Add Headnode</h4>
          <a class="close-link">
            <i class="fa fa-times" @click.prevent="closeaftermodal()"></i>
          </a>
        </div>

        <div
          class="form-group d-flex flex-column col-lg-10 mx-auto maxheightdesigncomplete pt-3"
        >
          <div>
            <label for="reportname" class="mt-2 mb-0">New Header Name</label>
            <input
              class="form-control"
              type="text"
              id="reportname"
              v-model="newheadnode"
              placeholder="New Heading Name"
            />
            <span class="errorClass" v-if="headnodeafterror == true">{{
              "Please enter a heading name"
            }}</span>
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button
              type="button"
              class="btn btn-primary px-4 py-0"
              @click="Saveheadnodeafter()"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="add_page_modal_wrapper" v-if="Addheadnodebeforepopup">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0">Add Headnode</h4>
          <a class="close-link">
            <i class="fa fa-times" @click.prevent="closebeforemodal()"></i>
          </a>
        </div>

        <div
          class="form-group d-flex flex-column col-lg-10 mx-auto maxheightdesigncomplete pt-3"
        >
          <div>
            <label for="reportname" class="mt-2 mb-0">New Header Name</label>
            <input
              class="form-control"
              type="text"
              id="reportname"
              v-model="newheadnode"
              placeholder="New Heading Name"
            />
            <span class="errorClass" v-if="headnodebeferror == true">{{
              "Please enter a heading name"
            }}</span>
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button
              type="button"
              class="btn btn-primary px-4 py-0"
              @click="Saveheadnodebefore()"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="add_page_modal_wrapper" v-if="editheadpopup">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0">{{ $t("navigations.update heading") }}</h4>
          <a class="close-link">
            <i class="fa fa-times" @click.prevent="closemodal()"></i>
          </a>
        </div>

        <div
          class="form-group d-flex flex-column col-lg-10 mx-auto maxheightdesigncomplete pt-3"
        >
          <div>
            <label for="reportname" class="mt-2 mb-0">Current Name</label>
            <input
              class="form-control"
              type="text"
              id="reportname"
              v-model="headingname"
              placeholder="Edit Heading Name"
              readonly
            />
          </div>
          <div>
            <label for="reportname" class="mt-2 mb-0">New Name</label>
            <input
              class="form-control"
              type="text"
              id="reportname"
              v-model="newheading"
              placeholder="New Heading Name"
            />
            <span class="errorClass" v-if="newheadnodeerror == true">{{
              "Please enter a heading name"
            }}</span>
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button
              type="button"
              class="btn btn-primary px-4 py-0"
              @click="onsave()"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <teleport to="#app">
    <div class="add_page_modal_wrapper" v-if="addpopup">
      <div class="option_modal__containers">
        <div
          class="add-block-title d-flex justify-content-between align-items-center px-3 py-2"
        >
          <h4 class="my-0">Add Report</h4>
          <a class="close-link">
            <i class="fa fa-times" @click.prevent="closemodalforcreate()"></i>
          </a>
        </div>

        <div
          class="form-group d-flex flex-column col-lg-10 mx-auto maxheightdesigncomplete pt-3"
        >
          <div>
            <label for="subreport">{{ addindex }}:</label>
            <input
              class="form-control"
              type="text"
              id="subreport"
              v-model="subreport"
              placeholder="Add Report"
            />
          </div>
          <div class="d-flex justify-content-center mt-2">
            <button
              type="button"
              class="btn btn-primary px-4 py-0"
              @click="createsave()"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  </teleport>
  <div
    class="blank-wrapper"
    v-if="initialLoader == true || initialRunLoader == true"
  >
    <div class="text-center">
      <h2 v-if="initialLoader == true">
        {{ $t("navigations.please wait while fetching programs") }}
      </h2>
      <h2 v-else>{{ $t("navigations.please wait") }}</h2>
      <img
        src="../../assets/img/loading.gif"
        width="15"
        alt="Waiting for login"
      />
    </div>
  </div>
  <!-- Create version starts -->
  <customModal
    v-if="createVersionModal == true"
    :containersm="true"
    @closeModal="closeVersionModal"
  >
    <template #title>
      {{ $t("navigations.create version") }}
    </template>
    <template #body>
      <div class="justify-content-center">
        <div class="mb-2">
          <label class="fs-7" for="interimVersion"
            >{{ $t("navigations.interim version")
            }}<sup><i class="fa fa-asterisk required"></i></sup
          ></label>
          <input
            type="text"
            v-model="interimVersion"
            class="form-control"
            name=""
            id="interimVersion"
            disabled
          />
          <div class="errorClass" v-if="errorMapper == true">
            {{ $t("navigations.please enter a value") }}
          </div>
        </div>
        <div class="mb-2">
          <label class="fs-7" for="interimComments">{{
            $t("navigations.comments")
          }}</label>
          <textarea
            type="text"
            v-model="interimComments"
            class="form-control"
            name=""
            id="interimComments"
          />
        </div>
        <div class="text-center px-0">
          <button
            type="button"
            class="save_btn px-3 py-2 position-relative"
            :disabled="showLoading == true"
            @click="generateToc()"
            :class="{ 'disabled-btn-cls': showLoading == true }"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': showLoading == false,
                'opacity-1': showLoading == true,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Waiting for login"
              />
            </div>
            <div
              :class="{
                'opacity-1': showLoading == false,
                'opacity-0': showLoading == true,
              }"
            >
              {{ $t("navigations.generate") }}
            </div>
          </button>
        </div>
      </div>
    </template>
  </customModal>
  <!-- Create version ends -->
  <!-- Map program starts -->
  <customModal
    v-if="mapProgrammePopup"
    :containermd="true"
    :bodymd="programme.length > 7 ? true : false"
    @closeModal="mapProgrammePopup = false"
  >
    <template #title>
      {{ $t("navigations.map macro") }}
    </template>
    <template #body>
      <div class="text-center" v-if="loading == true">
        <img
          src="../../assets/img/loading.gif"
          width="15"
          class=""
          alt="Waiting for login"
        />
      </div>
      <div>
        <table class="table shoping-cart-table">
          <tbody>
            <tr v-for="(pgmList, index) in programme" :key="pgmList._id">
              <td>
                <h4>
                  {{ pgmList.ProgramName }}
                </h4>
              </td>
              <td class="text-right">
                <button
                  @click="mapProgramme(pgmList, index)"
                  class="btn-xs btn-outline rounded position-relative px-4"
                >
                  <div
                    class="toc-loader position-absolute"
                    :class="{
                      'opacity-0': loadingBlock[index] == false,
                      'opacity-1': loadingBlock[index] == true,
                    }"
                  >
                    <img
                      src="../../assets/img/loading.gif"
                      width="15"
                      class="loading-btn-img"
                      alt="Waiting for login"
                    />
                  </div>
                  <div
                    :class="{
                      'opacity-1': loadingBlock[index] == false,
                      'opacity-0': loadingBlock[index] == true,
                    }"
                  >
                    {{ $t("navigations.map") }}
                  </div>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </customModal>
  <!-- Map program ends -->
  <!-- View program starts -->
  <customModal
    v-if="openViewModal"
    :containersm="true"
    :bodysm="true"
    :footerShow="false"
    :hideClose="false"
    :subContainer="false"
    @closeModal="openViewModal = false"
  >
    <template #title>
      {{ $t("navigations.view program") }}
    </template>
    <template #body>
      <div class="modal-scroll-body">
        <div class="details-grid">
          <div class="detail-row">
            <div class="label">Program Name</div>
            <div class="value">{{ viewprogramdata?.ProgramName || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Chart Type</div>
            <div class="value">{{ viewprogramdata?.ChartType || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Column Filters</div>
            <div class="value">
              {{
                viewprogramdata?.ColumnFilters?.length
                  ? viewprogramdata.ColumnFilters.join(", ")
                  : "N/A"
              }}
            </div>
          </div>
          <div class="detail-row">
            <div class="label">Column Value Filters</div>
            <div class="value">
              {{
                Object.keys(viewprogramdata?.ColumnValueFilters || {}).length
                  ? JSON.stringify(viewprogramdata.ColumnValueFilters)
                  : "N/A"
              }}
            </div>
          </div>
          <div class="detail-row">
            <div class="label">Unique Field</div>
            <div class="value">{{ viewprogramdata?.UniqueField || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Group By</div>
            <div class="value">{{ viewprogramdata?.GroupBy || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Include Total</div>
            <div class="value">
              {{ viewprogramdata?.IncludeTotal ? "Yes" : "No" }}
            </div>
          </div>
          <div class="detail-row">
            <div class="label">Numeric Operations</div>
            <div class="value">
              {{
                viewprogramdata?.NumericOperations?.length
                  ? viewprogramdata.NumericOperations.join(", ")
                  : "N/A"
              }}
            </div>
          </div>
          <div class="detail-row">
            <div class="label">Page Group</div>
            <div class="value">{{ viewprogramdata?.PageGroup || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Return Type</div>
            <div class="value">{{ viewprogramdata?.ReturnType || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Orientation</div>
            <div class="value">{{ viewprogramdata?.Orientation || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Report Type</div>
            <div class="value">{{ viewprogramdata?.ReportType || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Study Name</div>
            <div class="value">{{ viewprogramdata?.StudyName || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Report Name</div>
            <div class="value">{{ viewprogramdata?.ReportName || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">TOC Description</div>
            <div class="value">
              {{ viewprogramdata?.TocDescription || "N/A" }}
            </div>
          </div>
          <div class="detail-row">
            <div class="label">{{ $t("navigations.primary programmer") }}</div>
            <div class="value">
              {{ viewprogramdata?.DeveloperName || "N/A" }}
            </div>
          </div>
          <div class="detail-row">
            <div class="label">{{ $t("navigations.qc programmer") }}</div>
            <div class="value">{{ viewprogramdata?.QCName || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Status</div>
            <div class="value">{{ viewprogramdata?.Status || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Has Program</div>
            <div class="value">
              {{ viewprogramdata?.HasProgram ? "Yes" : "No" }}
            </div>
          </div>
          <div class="detail-row">
            <div class="label">Interim Version</div>
            <div class="value">
              {{ viewprogramdata?.InterimVersion || "N/A" }}
            </div>
          </div>
          <div class="detail-row">
            <div class="label">Location Type</div>
            <div class="value">
              {{ viewprogramdata?.LocationType || "N/A" }}
            </div>
          </div>
          <div class="detail-row">
            <div class="label">Location</div>
            <div class="value">{{ viewprogramdata?.Location || "N/A" }}</div>
          </div>
          <div class="detail-row">
            <div class="label">Program Type</div>
            <div class="value">{{ viewprogramdata?.ProgramType || "N/A" }}</div>
          </div>
        </div>
      </div>
    </template>
  </customModal>

  <!-- View program ends -->
  <!-- Report edit starts -->
  <customModal
    v-if="entryUpdateModal"
    :containersm="true"
    @closeModal="closeEntryUpdateModal"
  >
    <template #title>
      {{
        selectedUpdateOption === "update"
          ? $t("navigations.update report")
          : $t("navigations.add report")
      }}
    </template>
    <template #body>
      <div>
        <div v-if="selectedUpdateOption == 'update'">
          <label for="oldReportName" class="mt-2 mb-0">{{
            $t("navigations.current name")
          }}</label>
          <input
            class="form-control"
            type="text"
            id="oldReportName"
            v-model="oldReportName"
            placeholder="Edit Report Name"
            readonly
          />
        </div>
        <div>
          <label for="newReportName" class="mt-2 mb-0">{{
            $t("navigations.new name")
          }}</label>
          <input
            class="form-control"
            type="text"
            id="newReportName"
            v-model="newReportName"
            placeholder="Enter Report Name"
          />
          <span class="errorClass" v-if="newreportnameerror == true">{{
            "Please enter a Report name"
          }}</span>
        </div>
        <div class="d-flex justify-content-center mt-2">
          <button
            type="button"
            v-if="selectedUpdateOption == 'update'"
            class="save_btn px-5 position-relative"
            :disabled="loadingAssignBlock == true"
            @click.prevent="saveEntry('update')"
            :class="{ 'disabled-btn-cls': loadingAssignBlock == true }"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': loadingAssignBlock == false,
                'opacity-1': loadingAssignBlock == true,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Waiting for login"
              />
            </div>
            <div
              :class="{
                'opacity-1': loadingAssignBlock == false,
                'opacity-0': loadingAssignBlock == true,
              }"
            >
              {{ $t("navigations.save") }}
            </div>
          </button>
          <button
            type="button"
            v-else
            class="save_btn px-5 position-relative"
            :disabled="loadingAssignBlock == true"
            @click.prevent="saveEntry('add')"
            :class="{ 'disabled-btn-cls': loadingAssignBlock == true }"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': loadingAssignBlock == false,
                'opacity-1': loadingAssignBlock == true,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Waiting for login"
              />
            </div>
            <div
              :class="{
                'opacity-1': loadingAssignBlock == false,
                'opacity-0': loadingAssignBlock == true,
              }"
            >
              {{ $t("navigations.save") }}
            </div>
          </button>
        </div>
      </div>
    </template>
  </customModal>
  <!-- Report edit ends -->

  <!-- Report starts -->
  <customModal
    v-if="displayRun == true"
    :containermd="true"
    :bodyxl="true"
    @closeModal="closeReportModal('run')"
  >
    <template #title>
      {{ $t("navigations.reports") }} - {{ selectedReportName }}
    </template>
    <template #body>
      <div class="d-flex flex-column">
        <template v-for="(page, index) in files" :key="index">
          <iframe
            class="iframe-block"
            :id="`${page.Page}-${index}`"
            style="border: none"
          >
          </iframe>
        </template>
      </div>
    </template>
  </customModal>
  <!-- Report ends -->
  <!--Validation starts -->
  <customModal
    v-if="displayStatusModal == true"
    :containermd="true"
    @closeModal="displayStatusModal = false"
  >
    <template #title>
      {{ $t("navigations.validation status") }} - {{ selectedReportName }}-test
    </template>
    <template #body>
      <div class="d-flex">
        <div>{{ $t("navigations.change validation status from") }}</div>
        <div class="w-25 px-2">
          <select v-model="status" class="study-select">
            <option v-for="option in statusOptions" :key="option">
              {{ option.label }}
            </option>
          </select>
        </div>
        <div class="px-2">
          <div>{{ $t("navigations.to") }}</div>
        </div>
        <div class="w-25 px-2">
          <select v-model="changedStatus" class="study-select">
            {{
              statusOptionsDropdown
            }}
            <option v-for="option in statusOptionsDropdown" :key="option">
              {{ option.label }}
            </option>
          </select>
        </div>
      </div>
      <div class="mt-3">
        <label for="comments" class="form-label">
          Comments
          <span v-if="isCommentRequired" class="text-danger">*</span>
        </label>
        <textarea
          placeholder="Comments"
          v-model="statusComments"
          name="comments"
          id="comments"
          class="form-control"
          :class="{ 'border-danger': isCommentRequired && !statusComments }"
        ></textarea>

        <!-- Show error below the field -->
        <div
          v-if="validationError"
          class="text-danger mt-1"
          style="font-size: 0.875rem"
        >
          {{ validationError }}
        </div>
      </div>

      <div class="mt-3" v-if="status == 'Ready For Validation'">
        <div class="row">
          <div class="col-3">
            <input
              type="checkbox"
              class="mr-1"
              name=""
              value="Independent Programming"
              id="independentProgramming"
              v-model="selectedValidationType"
            /><label for="independentProgramming">{{
              $t("navigations.independent programming")
            }}</label>
          </div>
          <div class="col-3">
            <input
              type="checkbox"
              class="mr-1"
              name=""
              value="Manual Code Checking"
              id="manualCodeChecking"
              v-model="selectedValidationType"
            /><label for="manualCodeChecking">{{
              $t("navigations.manual code checking")
            }}</label>
          </div>
          <div class="col-3">
            <input
              type="checkbox"
              class="mr-1"
              name=""
              value="Manual Output Checking"
              id="manualOutputChecking"
              v-model="selectedValidationType"
            /><label for="manualOutputChecking">{{
              $t("navigations.manual output checking")
            }}</label>
          </div>
          <div class="col-3">
            <input
              type="checkbox"
              class="mr-1"
              name=""
              value="Program Review"
              id="programReview"
              v-model="selectedValidationType"
            /><label for="programReview">{{
              $t("navigations.program review")
            }}</label>
          </div>
        </div>
      </div>
      <div class="mt-3 text-center">
        <button
          type="button"
          class="save_btn px-5 position-relative"
          :disabled="loadingSaveBlock == true"
          @click.prevent="saveData()"
          :class="{ 'disabled-btn-cls': loadingSaveBlock == true }"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': loadingSaveBlock == false,
              'opacity-1': loadingSaveBlock == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <div
            :class="{
              'opacity-1': loadingSaveBlock == false,
              'opacity-0': loadingSaveBlock == true,
            }"
          >
            {{ $t("navigations.save") }}
          </div>
        </button>
      </div>
    </template>
  </customModal>
  <!-- Validation ends -->
  <!--Assign programmers starts -->
  <customModal
    v-if="openAssignModal == true"
    :containerxl="true"
    :bodymd="true"
    :footerShow="true"
    @closeModal="closeRunModal('assign')"
  >
    <template #title>
      {{ $t("navigations.assign programmers") }}
    </template>
    <template #body>
      <ul class="modal-tree pl-2">
        <li
          v-for="(node, index) in Object.keys(treeModal)"
          :key="`treeModal-${index}`"
        >
          {{ treeModal._id }}
          <input
            class="mr-2"
            type="checkbox"
            :id="`treeModal-${index}`"
            v-model="rootChecked[`treeModal-${index}`]"
            @change="
              toggleChildren(treeModal[node], index, `treeModal-${index}`)
            "
          />
          <label class="modal_tree_label" :for="`treeModal-${index}`"
            >{{ treeModal[node].Headingindex }}
            {{ treeModal[node].Headingname }}</label
          >
          <ul v-if="treeModal[node].Reports.length != 0">
            <li
              v-for="(childlabels, vindex) in treeModal[node].Reports"
              :key="`treeModal-${index}-${vindex}`"
            >
              <input
                class="mr-2"
                type="checkbox"
                @change="
                  toggleChild(
                    treeModal[node].Reports,
                    index,
                    vindex,
                    $event.target.checked
                  )
                "
                :id="`treeModal-${index}-${vindex}`"
                v-model="childrenChecked[`treeModal-${index}-${vindex}`]"
              />
              <label
                class="modal_tree_label"
                :for="`treeModal-${index}-${vindex}`"
                >{{ childlabels.Subindex }} {{ childlabels.Reportname }}
              </label>
              <ul class="pl-3">
                <li
                  v-for="(value, subindex) in childlabels.Programms"
                  :key="value.ReportId"
                >
                  <input
                    class="mr-2"
                    type="checkbox"
                    :id="`treeModal-${index}-${vindex}-${subindex}`"
                    v-model="
                      subchildrenChecked[
                        `treeModal-${index}-${vindex}-${subindex}`
                      ]
                    "
                  />
                  <label
                    :for="`treeModal-${index}-${vindex}-${subindex}`"
                    class="modal_tree_label px-1"
                    ><span v-if="value.Status != 'No Program'">
                      <span
                        :class="
                          getBadgeClass(value.Status, value.HasOutput, 'output')
                        "
                      ></span>
                      <span
                        :class="
                          getBadgeClass(value.Status, value.HasOutput, 'status')
                        "
                        class="mr-1"
                      ></span> </span
                    ><span v-if="value.Status && value.ReportType != null"
                      >{{ value.ReportType[0] }}
                    </span>
                    {{ childlabels.Subindex }}<span>.</span>{{ subindex + 1 }}
                    {{ value.ProgramName }} - <strong>{{ value.Version }}</strong>&nbsp; 


                    <!-- Status and Developer Information -->
                    <template v-if="value.Status != null">
                      <span
                        class="ml-2"
                        v-if="
                          value.DeveloperName != 'string' &&
                          value.DeveloperName != '' &&
                          value.DeveloperName != null
                        "
                      >
                       {{
                          $t("navigations.primary programmer")
                        }}
                        - <strong>{{ value.DeveloperName }}</strong></span                     
                      >
                      <span
                        class="px-1"
                        v-if="
                          value.QCName != 'string' &&
                          value.QCName != '' &&
                          value.QCName != null
                        "
                        >|</span
                      >
                      <span
                        v-if="
                          value.QCName != 'string' &&
                          value.QCName != '' &&
                          value.QCName != null
                        "
                      >
                        {{ $t("navigations.qc programmer") }} -
                        <strong>{{ value.QCName }}</strong></span
                      >
                    </template>
                  </label>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </template>
    <template #footer>
      <div class="row">
        <div class="col-6">
          <label for="programmer">{{
            $t("navigations.select primary programmer")
          }}</label>
          <select v-model="programmer" class="study-select" id="programmer">
            <option value="">{{ $t("navigations.none") }}</option>
            <option
              :value="user.fullName"
              v-for="user in userList"
              :key="user.id"
            >
              {{ user.fullName }}
            </option>
          </select>
        </div>
        <div class="col-6">
          <label for="qcprogrammer">{{
            $t("navigations.select qc programmer")
          }}</label>
          <select v-model="qcProgrammer" class="study-select" id="programmer">
            <option value="">{{ $t("navigations.none") }}</option>
            <option
              :value="user.fullName"
              v-for="user in userList"
              :key="user.id"
            >
              {{ user.fullName }}
            </option>
          </select>
        </div>
        <div class="col-12 mt-3 text-center">
          <button
            type="button"
            class="save_btn px-5 position-relative"
            :disabled="
              loadingAssignBlock == true ||
              (programmer == '' && qcProgrammer == '')
            "
            @click.prevent="assignProgrammer()"
            :class="{ 'disabled-btn-cls': loadingAssignBlock == true }"
          >
            <div
              class="toc-loader position-absolute"
              :class="{
                'opacity-0': loadingAssignBlock == false,
                'opacity-1': loadingAssignBlock == true,
              }"
            >
              <img
                src="../../assets/img/loading.gif"
                width="15"
                class="loading-btn-img"
                alt="Waiting for login"
              />
            </div>
            <div
              :class="{
                'opacity-1': loadingAssignBlock == false,
                'opacity-0': loadingAssignBlock == true,
              }"
            >
              {{ $t("navigations.save") }}
            </div>
          </button>
        </div>
      </div>
    </template>
  </customModal>

  <!-- Data Set Configuration Popup -->
  <customModal
    v-if="openStats == true"
    :containersm="true"
    :bodysm="true"
    :footerShow="true"
    @closeModal="closeRunModal('stats')"
  >
    <template #title>
      {{ $t("navigations.data set configuration") }}
    </template>
    <template #body>
      <div class="row">
        <div class="col-12 my-3">
          <label for="datasetName"
            >{{ $t("navigations.toc version") }} :
            <strong>{{ intversion }}</strong></label
          >
        </div>
        <div class="col-6 mb-3">
          <label class="mb-0" for="datasetType">{{
            $t("navigations.dataset version")
          }}</label>
          <select
            name="interim version"
            placeholder="Search"
            class="form-select"
            v-model="dataSetConfig.DatasetVersion"
            id="interimVersion"
          >
            <option value="" selected>None</option>
            <option
              v-for="version in interimVersions"
              :key="version"
              :value="version"
            >
              {{ version }}
            </option>
          </select>
          <span class="errorClass text-danger" v-if="showDatasetVersionError">
            {{ $t("navigations.please select data set version") }}
          </span>
        </div>
        <div class="col-6 mb-3">
          <label class="mb-0" for="datasetType">{{
            $t("navigations.location")
          }}</label>
          <select
            id="datasetType"
            v-model="dataSetConfig.DatasetLocation"
            class="form-control"
          >
            <option value="" selected >{{ $t("navigations.select") }}</option>
            <option v-if="dataSetConfig.DatasetLocation=='database'" value="database">{{ $t("navigations.database") }}</option>
            <option v-else value="database">{{ $t("navigations.database") }}</option>
            <option v-if="dataSetConfig.DatasetLocation=='datalake'" value="datalake">{{ $t("navigations.datalake") }}</option>
            <option v-else value="datalake">{{ $t("navigations.datalake") }}</option>

          </select>
          <span class="errorClass text-danger" v-if="showLocationError">
            {{ $t("navigations.please select location") }}
          </span>
        </div>
        <div v-if="dataSetConfig.DatasetLocation == 'datalake'" class="col-12">
          <label class="mb-0" for="datasetName">{{
            $t("navigations.folder")
          }}</label>
          <input
            type="text"
            id="datasetName"
            v-model="dataSetConfig.DatasetFolder"
            class="form-control"
            placeholder="Enter folder name"
          />
          <span class="errorClass text-danger" v-if="showFolderError">
            {{ $t("navigations.please enter folder name") }}
          </span>
        </div>
        <!-- Add more configuration fields as needed -->
      </div>
    </template>
    <template #footer>
      <div class="col-12 text-center">
        <button
          type="button"
          class="save_btn px-5 position-relative"
          :disabled="loadingStatsBlock"
          @click.prevent="
            saveConfig ? saveDatasetConfig() : updateDatasetConfig()
          "
          :class="{ 'disabled-btn-cls': loadingStatsBlock }"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': !loadingStatsBlock,
              'opacity-1': loadingStatsBlock,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Loading"
            />
          </div>
          <div
            :class="{
              'opacity-1': !loadingStatsBlock,
              'opacity-0': loadingStatsBlock,
            }"
          >
            {{ saveConfig ? $t("navigations.save") : $t("navigations.update") }}
          </div>
        </button>
      </div>
    </template>
  </customModal>
  <!--Assign programmers ends -->
  <!--Copy Move section starts -->
  <customModal
    v-if="openCopyMoveModal == true"
    :containerxl="true"
    :bodymd="true"
    @closeModal="closeCopyMoveModal()"
  >
    <template #title>
      {{ $t("navigations.select") }}&nbsp;{{ selectedModal }}&nbsp;{{
        $t("navigations.location")
      }}
    </template>
    <template #body>
      <ul class="tree pl-2">
        <li
          v-for="(node, index) in Object.keys(treeModal)"
          :key="`treeCopyModal-${index}`"
        >
          {{ treeModal._id }}
          <input
            class="mr-2"
            type="checkbox"
            :id="`treeCopyModal-${index}`"
            disabled
            :checked="openCopyMoveModal == true"
          />
          <label
            class="tree_label"
            :for="`treeCopyModal-${index}`"
            @click.prevent="
              copyMove(
                treeModal[node].Headingname,
                treeData[node].Headingid,
                '',
                'heading'
              )
            "
            >{{ treeModal[node].Headingindex }}
            {{ treeModal[node].Headingname }}</label
          >
          <ul v-if="treeModal[node].Reports.length != 0">
            <li
              v-for="(childlabels, vindex) in treeModal[node].Reports"
              :key="`treeCopyModal-${index}-${vindex}`"
            >
              <input
                class="mr-2"
                type="checkbox"
                :checked="openCopyMoveModal == true"
                disabled
                :id="`treeCopyModal-${index}-${vindex}`"
              />
              <label
                class="tree_label"
                @click.prevent="
                  copyMove(childlabels, treeData[node].Headingid, '', 'report')
                "
                :for="`treeCopyModal-${index}-${vindex}`"
                >{{ childlabels.Subindex }} {{ childlabels.Reportname }}
              </label>
              <ul class="pl-3">
                <li
                  v-for="(value, subindex) in childlabels.Programms"
                  :key="value.ReportId"
                >
                  <input
                    class="mr-2"
                    type="checkbox"
                    :checked="openCopyMoveModal == true"
                    disabled
                    :id="`treeCopyModal-${index}-${vindex}-${subindex}`"
                  />
                  <label
                    :for="`treeCopyModal-${index}-${vindex}-${subindex}`"
                    @click.prevent="
                      copyMove(
                        childlabels,
                        treeData[node].Headingid,
                        value,
                        'program'
                      )
                    "
                    class="tree_label px-1"
                    ><span v-if="value.Status != 'No Program'">
                      <span
                        :class="
                          getBadgeClass(value.Status, value.HasOutput, 'output')
                        "
                      ></span>
                      <span
                        :class="
                          getBadgeClass(value.Status, value.HasOutput, 'status')
                        "
                        class="mr-1"
                      ></span> </span
                    ><span v-if="value.Status && value.ReportType != null"
                      >{{ value.ReportType[0] }}
                    </span>
                    {{ childlabels.Subindex }}<span>.</span>{{ value.Version }}
                    {{ value.ProgramName }} - <strong>{{ value.Version }}</strong>&nbsp;


                    <!-- Status and Developer Information -->
                    <template v-if="value.Status != null">
                      <span
                        class="ml-2"
                        v-if="
                          value.DeveloperName != 'string' &&
                          value.DeveloperName != '' &&
                          value.DeveloperName != null
                        "
                      >
                        {{
                          $t("navigations.primary programmer")
                        }}
                        - <strong>{{ value.DeveloperName }}</strong></span                      
                      >
                      <span
                        class="px-1"
                        v-if="
                          value.QCName != 'string' &&
                          value.QCName != '' &&
                          value.QCName != null
                        "
                        >|</span
                      >
                      <span
                        v-if="
                          value.QCName != 'string' &&
                          value.QCName != '' &&
                          value.QCName != null
                        "
                      >
                        {{ $t("navigations.qc programmer") }} -
                        <strong>{{ value.QCName }}</strong></span                       
                      >
                    </template>
                  </label>
                </li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </template>
  </customModal>
  <!--Copy Move section ends -->
  <!--Run multiple programs starts -->
  <customModal
    v-if="openMultipleRun === true"
    :containerxl="true"
    :bodymd="true"
    :footerShow="true"
    @closeModal="closeRunModal('run')"
  >
    <template #title>
      {{ $t("navigations.custom program run") }}
    </template>
    <template #body>
      <div class="row">
        <div class="col-6">
          <h6>{{ $t("navigations.analysis tree") }}</h6>
          <div class="height-450 mt-4">
            <ul class="modal-tree pl-2">
              <li
                v-for="(node, index) in Object.keys(treeModal)"
                :key="`treeModal-${index}`"
              >
                {{ treeModal._id }}
                <input
                  class="mr-2"
                  type="checkbox"
                  :id="`treeModal-${index}`"
                  v-model="rootChecked[`treeModal-${index}`]"
                  @change="
                    toggleChildren(treeModal[node], index, `treeModal-${index}`)
                  "
                />
                <label class="modal_tree_label" :for="`treeModal-${index}`"
                  >{{ treeModal[node].Headingindex }} {{ node }}</label
                >
                <ul v-if="treeModal[node].Reports.length != 0">
                  <li
                    v-for="(childlabels, vindex) in treeModal[node].Reports"
                    :key="`treeModal-${index}-${vindex}`"
                  >
                    <input
                      class="mr-2"
                      type="checkbox"
                      @change="
                        toggleChild(
                          childlabels.Programms,
                          index,
                          vindex,
                          $event.target.checked
                        )
                      "
                      :id="`treeModal-${index}-${vindex}`"
                      v-model="childrenChecked[`treeModal-${index}-${vindex}`]"
                    />
                    <label
                      class="modal_tree_label"
                      :for="`treeModal-${index}-${vindex}`"
                      >{{ childlabels.Subindex }} {{ childlabels.Reportname }}
                    </label>
                    <ul class="pl-3">
                      <li
                        v-for="(value, subindex) in childlabels.Programms"
                        :key="value.ReportId"
                      >
                        <input
                          class="mr-2"
                          type="checkbox"
                          :id="`treeModal-${index}-${vindex}-${subindex}`"
                          v-model="
                            subchildrenChecked[
                              `treeModal-${index}-${vindex}-${subindex}`
                            ]
                          "
                          @change="
                            toggleSubChild(
                              index,
                              vindex,
                              subindex,
                              $event.target.checked,
                              value.Version,
                              value
                            )
                          "
                        />
                        <label
                          :for="`treeModal-${index}-${vindex}-${subindex}`"
                          class="modal_tree_label px-1"
                          ><span v-if="value.Status && value.ReportType != null"
                            >{{ value.ReportType[0] }}
                          </span>
                          {{ childlabels.Subindex }}<span>.</span
                          >{{ subindex + 1 }}
                          <span>{{ value.ProgramName }} </span>
                        </label>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-6">
          <h6>{{ $t("navigations.selected entries") }}</h6>
          <div
            class="mt-4"
            :class="{ 'height-450': selectedPrograms.length > 10 }"
          >
            <div class="pl-2">
              <div
                v-for="childlabels in selectedPrograms"
                :key="childlabels.report"
              >
                <div
                  class="d-flex"
                  v-for="(value, subindex) in childlabels.programs"
                  :key="value._id"
                >
                  <div
                    role="button"
                    class="cursor-pointer mr-2"
                    @click.prevent="
                      deleteProgram(
                        childlabels.nodeIndex,
                        childlabels.reportIndex,
                        subindex,
                        value.Version
                      )
                    "
                  >
                    <img
                      class="delete-icon mb-1"
                      src="../../assets/img/red_minus.svg"
                      alt="remove program"
                    />
                  </div>
                  <label :for="`selectedProgram-${subindex}`"
                    ><span v-if="value.Status && value.ReportType != null"
                      >{{ value.ReportType[0] }}
                    </span>
                    {{ childlabels.subIndex }}<span>.</span>{{ subindex + 1 }}
                    <span v-if="value.ProgramName">{{
                      value.ProgramName
                    }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template #footer>
      <div class="col-12 text-center">
        <button
          type="button"
          class="save_btn px-5 position-relative"
          :disabled="loadingAssignBlock == true"
          @click.prevent="runMultiplePrograms()"
          :class="{ 'disabled-btn-cls': loadingAssignBlock == true }"
        >
          <div
            class="toc-loader position-absolute"
            :class="{
              'opacity-0': loadingAssignBlock == false,
              'opacity-1': loadingAssignBlock == true,
            }"
          >
            <img
              src="../../assets/img/loading.gif"
              width="15"
              class="loading-btn-img"
              alt="Waiting for login"
            />
          </div>
          <div
            :class="{
              'opacity-1': loadingAssignBlock == false,
              'opacity-0': loadingAssignBlock == true,
            }"
          >
            {{ $t("navigations.run") }}
          </div>
        </button>
      </div>
    </template>
  </customModal>
  <!--Run multiple programs ends -->
  <!-- Validation ends -->
  <!--Programs History starts -->
  <customModal
    v-if="displayProgramModal == true"
    :containermd="true"
    :bodymd="true"
    @closeModal="closeProgramHistory()"
  >
    <template #title>
      {{ $t("navigations.program history") }} -
      <template v-if="programList && programList[0]">
        {{ programList[0].ReportName }}
      </template>
    </template>
    <template #body>
      <div class="text-center" v-if="loading == true">
        <img
          src="../../assets/img/loading.gif"
          width="15"
          class=""
          alt="Waiting for login"
        />
      </div>
      <template v-else>
        <div v-if="mapValue == null && mapValue.length == 0">
          <h3>{{ $t("navigations.no programs available") }}</h3>
        </div>
        <div v-else>
          <table class="table shoping-cart-table">
            <thead>
              <th>{{ $t("navigations.datetime") }}</th>
              <th>{{ $t("navigations.primary programmer") }}</th>
              <th>{{ $t("navigations.status") }}</th>
              <th>{{ $t("navigations.version") }}</th>
              <th class="text-center">{{ $t("navigations.actions") }}</th>
            </thead>
            <tbody>
              <tr v-for="value in programList" :key="value._id">
                <td>
                  {{ filterDate(value.CreatedAt) }} <br /><span class="mt-1">{{
                    filterTime(value.CreatedAt)
                  }}</span>
                </td>
                <td>
                  {{ value.DeveloperName }}
                </td>
                <td>
                  <span
                    class="px-2"
                    v-if="
                      value.Status == 'No Output' ||
                      value.Status == 'No Program'
                    "
                  >
                    <span class="badge badge-black">{{ value.Status }}</span>
                  </span>
                  <span
                    class="px-2"
                    v-if="
                      value.Status == 'Old Output' ||
                      value.Status == 'Ready For Validation'
                    "
                  >
                    <span class="badge badge-danger">{{ value.Status }}</span>
                  </span>
                  <span class="px-2" v-if="value.Status == 'In Development'">
                    <span class="badge badge-warning">{{ value.Status }}</span>
                  </span>
                  <span class="px-2" v-if="value.Status == 'Current Output'">
                    <span class="badge badge-orange">{{ value.Status }}</span>
                  </span>
                  <span class="px-2" v-if="value.Status == 'Validated'">
                    <span class="badge badge-grn">{{ value.Status }}</span>
                  </span>
                </td>
                <td>
                  {{ value.Version }}
                </td>
                <td class="d-flex justify-content-center">
                  <div
                    class="px-2 position-relative"
                    :class="{ 'tooltip-hidden': setProgram == true }"
                  >
                    <span @click="mapSubFun('set program', value._id)">
                      <img
                        class="act_ico"
                        src="./../../../src/assets/img/set_default.png"
                        alt=""
                      />
                    </span>
                    <div class="set-program-tooltip">
                      {{ $t("navigations.set as current program") }}
                    </div>
                  </div>
                  <div
                    class="px-2 position-relative"
                    :class="{ 'tooltip-hidden': compareProgram == true }"
                  >
                    <span @click="toggleComparison(value._id)">
                      <img
                        class="act_ico"
                        src="./../../../src/assets/img/compare.png"
                        alt=""
                      />
                    </span>
                    <div class="compare-program-tooltip">
                      {{ $t("navigations.compare this with current program") }}
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>
      <div class="row mx-0">
        <div class="col-lg-12 mx-0 px-0">
          <div
            class="dataTables_paginate paging_simple_numbers pagination float-right"
          >
            <div class="col-lg-12 d-flex justify-content-lg-end px-0">
              <v-pagination
                v-model="historyPageNumber"
                :pages="historyTotalPages"
                :range-size="0"
                active-color="#618bd7"
                @update:modelValue="loadPage"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal>
  <!--Programs History ends -->
  <!--Programs comparison starts -->
  <customModal
    v-if="displayProgramComparison == true"
    :containermd="true"
    :subContainer="true"
    :bodyxl="true"
    @closeModal="closeSub()"
  >
    <template #subContainerTitle>
      {{ $t("navigations.program comparison") }}
    </template>
    <template #subContainerBody>
      <div class="text-center" v-if="loading == true">
        <img
          src="../../assets/img/loading.gif"
          width="15"
          class=""
          alt="Waiting for login"
        />
      </div>
      <div class="table-responsive height-450" v-else>
        <table class="table table-striped table-bordered comparison-table">
          <thead>
            <tr>
              <th>Field</th>
              <th>Version : {{ object1.Version }}</th>
              <th>Version : {{ object2.Version }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(value, key) in comparisonData" :key="key">
              <td>{{ key }}</td>
              <td>
                <template v-if="Array.isArray(value.obj1)">
                  <pre>{{ JSON.stringify(value.obj1, null, 2) }}</pre>
                </template>
                <template v-else>
                  {{ value.obj1 }}
                </template>
              </td>
              <td :class="{ highlight: value.diff }">
                <template v-if="Array.isArray(value.obj2)">
                  <pre>{{ JSON.stringify(value.obj2, null, 2) }}</pre>
                </template>
                <template v-else>
                  {{ value.obj2 }}
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </customModal>
  <!--Programs comparison ends -->
  <!--View output starts -->
  <customModal
    v-if="displayOutput == true"
    :bodyxl="loader == true ? false : true"
    :containermd="true"
    @closeModal="closeReportModal('output')"
  >
    <template #title>
      {{ $t("navigations.view output") }} - {{ selectedReportName }}
    </template>
    <template #body>
      <div class="text-center" v-if="loader == true">
        <img
          src="../../assets/img/loading.gif"
          width="15"
          class=""
          alt="Waiting for login"
        />
      </div>
      <div v-else>
        <div class="d-flex flex-column">
          <iframe
            class="iframe-block"
            id="combined-output"
            frameborder="0"
            style="width: 100%; height: 100vh"
          ></iframe>
        </div>
      </div>
    </template>
  </customModal>
  <!--View output  ends -->
  <!-- modal ends -->
</template>
<script src="./tocgenerate.js"></script>
<style scoped>
@import "./tree.css";
@import "../../assets/css/style.css";
.modal-scroll-body {
  max-height: 60vh; /* Adjust as needed */
  overflow-y: auto;
  padding-right: 10px; /* So scrollbar doesn't overlap text */
}

.details-grid {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 6px 0;
  border-bottom: 1px solid #eee;
}

.detail-row div {
  flex: 1;
  color: #333;
  font-size: 13px;
}
.detail-row .label {
  flex: 0 0 35%;
  font-weight: 600;
  padding-left: 0px !important;
  padding-right: 10px;
  background-color: transparent !important;
}

.detail-row .value {
  flex: 1;
  word-break: break-word;
  text-align: left;
  background-color: transparent !important;
}
.page-divider img {
  max-width: 100%;
}
.highlight {
  background-color: #ffeb3b;
}
.comparison-table {
  table-layout: fixed;
  width: 100%;
}
.comparison-table tbody tr td:first-child,
.comparison-table thead tr th:first-child {
  background-color: hsl(0, 0%, 100%);
  position: sticky;
  left: -1px;
}
.comparison-table tbody tr td:nth-child(2),
.comparison-table tbody tr td:nth-child(3) {
  width: 40%;
  white-space: break-spaces;
}
.modal-tree input:checked ~ ul {
  display: block;
}

:checked ~ label.tree_label:before {
  content: url("../../assets/images/folder-close.png");
}

.modal-tree .tree_label:after {
  display: none;
}

label.modal_tree_label:before {
  color: #fff;
  position: relative;
  z-index: 1;
  float: left;
  margin: 0 1em 0 -2em;
  width: 1em;
  height: 1em;
  border-radius: 1em;
  text-align: center;
  line-height: 0.8em;
}
.linkstyle {
  cursor: pointer;
}

.settings-block {
  font-size: 1rem;
  color: hsl(0, 0%, 50%);
  border: none;
  transition: transform 0.5s ease-in-out, background-color 0.5s ease-in-out;
}
.settings-block .settings-icon {
  transform-origin: center center;
}
.settings-block:hover .settings-icon {
  animation: rotate90 0.8s linear;
}
@keyframes rotate90 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(90deg);
  }
}

/* .position-relative:hover .settings-icon
{
  transform:rotate(360deg);
} */
.skip-all-bg {
  text-align: center;
  border-color: hsl(187, 100%, 38%);
  color: white !important;
  padding: 0.3rem 0.4rem;
  border-radius: 0.25rem;
  cursor: pointer;
  transition: background-color 0.3s ease-in-out;
  background-color: hsl(187, 100%, 38%);
}

.settings-tooltip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.2rem 0.8rem;
  right: 10px;
  top: 25px;
  font-size: 0.7rem;
  font-weight: 200;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.position-relative:hover .settings-tooltip,
.position-relative:focus-within .settings-tooltip,
.position-relative:focus-visible .settings-tooltip {
  visibility: visible;
  transition: visibility 30ms ease-in;
}
.position-relative.tooltip-hidden .settings-tooltip {
  display: none !important;
}

.position-relative .set-program-tooltip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 35px;
  top: -10px;
  font-size: 0.8rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.position-relative:hover .set-program-tooltip,
.position-relative:focus-within .set-program-tooltip,
.position-relative:focus-visible .set-program-tooltip {
  visibility: visible;
  transition: visibility 30ms ease-in;
}
.position-relative.tooltip-hidden .set-program-tooltip {
  display: none !important;
}
.position-relative .compare-program-tooltip {
  visibility: hidden;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 35px;
  top: -10px;
  font-size: 0.8rem;
  position: absolute;
  z-index: 1;
  transition: visibility 75ms ease-in;
}

.position-relative:hover .compare-program-tooltip,
.position-relative:focus-within .compare-program-tooltip,
.position-relative:focus-visible .compare-program-tooltip {
  visibility: visible;
  transition: visibility 30ms ease-in;
}
.position-relative.tooltip-hidden .compare-program-tooltip {
  display: none !important;
}
.linkstyle {
  cursor: pointer;
}
.add-block-title {
  color: #ffffff;
  background-color: #768dd3;
}
.option_modal__containers {
  width: min(600px, 90%);
  background: #fff;
  border-radius: 4px;
  overflow: auto;
  min-height: 150px;
  position: fixed;
  margin-top: 100px;
  max-height: 400px;
}
.add_page_modal_wrapper,
.modal__wrapper__component {
  position: absolute;
  inset: 0;
  background: rgb(0 0 0 / 18%);
  height: 100pc;
  width: 100%;
  display: flex;
  justify-content: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 3000;
}
.sub-level-menu:hover,
.level-menu:hover {
  background-color: rgba(0, 0, 0, 0.06);
}

.toc-side-popup {
  position: absolute;
  text-align: left;
  top: 6px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: #fff;
  width: Auto;
  box-shadow: 3px 3px 3px hsla(0, 0%, 62.7%, 0.5);
  z-index: 200;
}

.toc-side-popup > div {
  cursor: pointer;
  padding: 0.5rem;
}

.toc-side-popup > div:hover {
  background-color: #e4eaf9;
}

.float-right .tool-tip {
  visibility: hidden;
  width: max-content;
  background-color: #616161;
  color: #fff;
  text-align: center;
  border-radius: 0.3em;
  padding: 0.1rem 0.8rem;
  right: 15px;
  top: -15px;
  font-size: 0.8rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  -webkit-transition: visibility 75ms ease-in;
  transition: visibility 75ms ease-in;
}

.plan-side-popup > div {
  cursor: pointer;
  padding: 0.5rem;
}

.plan-side-popup > div:hover {
  background-color: #e4eaf9;
}

.horizondalscroll {
  overflow-y: auto;
  max-height: 500px;
}

.modal__title {
  background-color: #618bd7;
  color: #fff;
}
.toc-side-popup-sub {
  position: absolute;
  text-align: left;
  right: 45px;
  top: 13px;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  width: fit-content;
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}

.toc-side-popup-sub > div {
  cursor: pointer;
  padding: 0.6rem 0.8rem;
}

.toc-side-popup-sub > div:hover {
  background-color: #e4eaf9;
}

.opacity-05 {
  opacity: 0.5;
}

.opacity-0 {
  opacity: 0;
}

.opacity-1 {
  opacity: 1;
}

.left-220 {
  left: 220px;
}

.right-50 {
  right: 50px;
}
.right-25 {
  right: 25px;
}
.delete-icon {
  width: 1em;
}
.badge-black {
  background-color: rgb(10, 10, 10);
}
.badge-red {
  background-color: rgb(255, 0, 0);
}
.border-black {
  border-color: #000;
}
.toc-badge {
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 600;
  font-size: 0.7rem;
  color: #fff;
  border-radius: 0.25rem;
  text-shadow: none;
  white-space: nowrap;
}
.rounded-radius {
  border-radius: 30px;
}
.blank-wrapper {
  position: fixed;
  inset: 0;
  background: rgb(0 0 0 / 30%);
  color: rgb(255, 255, 255);
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  z-index: 3000;
  /* pointer-events: none; */
}
.height-450 {
  height: 450px;
  overflow-y: scroll;
}
.highlighted-background {
  background-color: hsl(0, 0%, 93%);
}
.iframe-block {
  width: 100%;
  height: 500px;
}
.iframe-block-visible {
  overflow: visible;
  /* height:100vh;
  overflow:visible;
  max-height: 100%; */
}
.multiselect-theme {
  --ms-option-bg-selected-pointed: rgb(210, 210, 210);
  --ms-option-bg-selected: rgb(210, 210, 210);
  --ms-option-color-selected: #000;
  --ms-option-color-selected-pointed: #000;
  --ms-tag-color: #000;
  --ms-tag-font-size: 0.7rem;
  --ms-tag-bg: rgb(210, 210, 210);
}

.disabled-btn-cls {
  opacity: 0.6;
  pointer-events: none;
}

.custom-badge {
  display: inline-block;
  width: 13px;
  height: 13px;

  line-height: 28px;
  position: relative;
  top: 1px;
}
.status-b-radius {
  border-radius: 3px;
}

/* Popver style starts; */
.ellipsis-btn {
  anchor-name: --manage-btn;
  border: 0;
}

.ellipsis-btn:hover {
  background-color: rgba(234, 234, 234, 1);
}
.popup-menu,
.popup-submenu {
  position: absolute;
  inset: auto;
  text-align: left;
  border-radius: 5px;
  border: 1px solid #e7eaec;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 3px 3px 3px rgba(160, 160, 160, 0.5);
  z-index: 200;
}
.popup-menu {
  position-try-fallbacks: --bottom;
  top: anchor(bottom);
  right: anchor(right);
  width: 160px;
}
.popup-submenu {
  top: anchor(bottom);
  right: anchor(left);
  width: fit-content;
  margin-inline-end: 5px;
}

.popup-menu > div,
.popup-submenu > div {
  cursor: pointer;
  padding: 0.6rem 0.8rem;
}
.popup-menu > button {
  border: 0;
  font-size: 0.8rem;
  font-weight: 400;
  color: rgba(0, 0, 0);
  padding: 0.6rem 0.8rem;
}
.popup-menu > .popup-menu-block:hover,
.popup-submenu > div:hover,
.popup-menu > button:hover {
  background-color: #e4eaf9;
}
[popover]:popover-open {
  display: flex;
  flex-direction: column;
  align-items: baseline;
  animation: fadeIn 0.2s ease-in-out;
}

.nested-popover-btn {
  display: block;
  margin-top: 5px;
  background: #f1f1f1;
  border: none;
  padding: 5px;
  cursor: pointer;
  width: 100%;
  text-align: left;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

@position-try --bottom {
  inset: auto;
  bottom: anchor(top);
  right: anchor(left);
}
/* Popver style ends */
/* Tab CSS starts*/
.modal-nav.modal-nav-tabs li {
  background: none;
  border: none;
}
.modal-nav-tabs > li > a {
  display: inline-block;
  color: #6d6d6d;
  font-weight: 700;
}
.modal-nav-tabs .modal-nav-link {
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  padding: 5px 20px;
}
.modal-nav-tabs .modal-nav-link:hover,
.modal-nav-tabs .modal-nav-link:focus {
  border-color: #e9ecef #e9ecef #dee2e6;
  isolation: isolate;
}
.modal-nav-tabs .modal-nav-link.disabled {
  color: #6c757d;
  background-color: transparent;
  border-color: transparent;
}
.modal-nav-tabs .modal-nav-link.active,
.modal-nav-tabs .nav-item.show .modal-nav-link {
  color: #495057;
  background-color: #fff;
  border-color: #dee2e6 #dee2e6 #fff;
}
.ibox-tab-content {
  color: inherit;
  padding: 10px;
  border-color: #eeeeee;
  -o-border-image: none;
  border-image: none;
  border-top-style: solid;
  border-top-width: 1px;
}
.act_ico {
  width: 16px;
  height: 16px;
}
/* Tab CSS ends */

.stat-badge {
  border: none;
  border-radius: 0px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
  transition: transform 0.2s;
}
.border-2 {
  border-width: 3px !important;
}

.badge-border-black {
  border-color: #000000 !important;
}
.badge-border-yellow {
  border-color: #f8ac59 !important;
}
.badge-border-red {
  border-color: #ed5565 !important;
}
.badge-border-green {
  border-color: #1ab394 !important;
}
.text-danger {
  color: red;
}
.border-danger {
  border: 1px solid red;
}
</style>
